import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlanoContasEmpresaDetalharRoutingModule } from './plano-contas-empresa-detalhar-routing.module';
import { PlanoContasEmpresaDetalharComponent } from './plano-contas-empresa-detalhar.component';
import { DividerModule } from 'primeng/divider';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';


@NgModule({
  declarations: [
    PlanoContasEmpresaDetalharComponent
  ],
  imports: [
    CommonModule,
    PlanoContasEmpresaDetalharRoutingModule,
    DividerModule,
    ButtonModule,
    MessagesModule,
    ProgressSpinnerModule
  ]
})
export class PlanoContasEmpresaDetalharModule { }
